var _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCentralized(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 52,
    viewBox: "0 0 280 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 14 L24 2 L38 14",
    stroke: "#1E1E1E",
    strokeWidth: 2.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 20,
    height: 16,
    stroke: "#1E1E1E",
    strokeWidth: 2.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 20,
    width: 4,
    height: 10,
    fill: "#1E1E1E"
  }))), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 36,
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 22,
    fill: "#1E1E1E",
    style: {
      letterSpacing: "-0.5px"
    }
  }, "Centralized"), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 172,
    y: 36,
    fontFamily: "Arial, sans-serif",
    fontWeight: 400,
    fontSize: 22,
    fill: "#1E1E1E"
  }, "Platform")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentralized);
export default __webpack_public_path__ + "static/media/centralized.0c741e43002d1f1b3c7890f7f51d4f33.svg";
export { ForwardRef as ReactComponent };